import mapKeys from 'lodash/mapKeys';

import { Apps } from '@/constants/apps';

function getApp(): Apps | null {
  const path = window.location.pathname;
  const appName = path.split('/')[1];
  switch (appName) {
    case 'homescapes':
      return Apps.Homescapes;
    case 'township':
      return Apps.Township;
    default:
      return null;
  }
}

function generateUniqueId(): string {
  const postfixSet = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const postfixLength = 8;

  // Получение текущей даты и времени
  const now = new Date();
  const day = String(now.getUTCDate()).padStart(2, '0');
  const month = String(now.getUTCMonth() + 1).padStart(2, '0'); // месяцы начинаются с 0
  const year = String(now.getUTCFullYear());
  const hours = String(now.getUTCHours()).padStart(2, '0');
  const minutes = String(now.getUTCMinutes()).padStart(2, '0');
  const seconds = String(now.getUTCSeconds()).padStart(2, '0');

  const prefix = `${day}${month}${year}-${hours}${minutes}${seconds}-`;

  // Generate the random postfix
  let postfix = '';
  for (let i = 0; i < postfixLength; i += 1) {
    const randomIndex = Math.floor(Math.random() * postfixSet.length);
    postfix += postfixSet[randomIndex];
  }

  return prefix + postfix;
}

function randomAlphaNumeric(length: number): string {
  const ALPHA_NUMERIC_CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const { length: charLength } = ALPHA_NUMERIC_CHARSET;

  const values = crypto.getRandomValues(new Uint32Array(length));

  return Array.from(values, rand => {
    return ALPHA_NUMERIC_CHARSET[rand % charLength];
  }).join('');
}

function randomNumberRange(from: number, to: number): number {
  const values = crypto.getRandomValues(new Uint32Array(1));

  const value = values[0] / (0xffffffff + 1);

  const min = Math.ceil(from);
  const max = Math.floor(to);

  return Math.floor(value * (max - min + 1)) + min;
}

function parseSearchParams(search: string): Dictionary<string> {
  return Object.fromEntries(new URLSearchParams(search));
}

function setURLQueryParams(url: string, params: Dictionary<never>): string {
  const result = new URL(url);

  Object.entries(params).forEach(([key, val]) => {
    result.searchParams.set(key, String(val));
  });

  return result.toString();
}

function buildLocationHostUrl(): string {
  const { host, pathname } = window.location;

  return `${host}${pathname}`;
}

function filterObject<T>(obj: Dictionary<T>, keys: Array<string>): Dictionary<T> {
  const result: Dictionary<T> = {};

  keys.forEach(key => {
    if (!(key in obj)) {
      return;
    }

    result[key] = obj[key];
  });

  return result;
}

function filterOutEmptyValues<T>(obj: Dictionary<T>): Dictionary<T> {
  const result: Dictionary<T> = {};

  Object.entries(obj).forEach(([key, val]) => {
    if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
      return;
    }

    result[key] = val;
  });

  return result;
}

function convertObjectKeys<T>(obj: Dictionary<T>, keysDict: Dictionary<string>): Dictionary<T> {
  return mapKeys(obj, (_, key) => keysDict[key] || key);
}

export {
  getApp,
  generateUniqueId,
  randomAlphaNumeric,
  randomNumberRange,
  parseSearchParams,
  setURLQueryParams,
  filterObject,
  convertObjectKeys,
  buildLocationHostUrl,
  filterOutEmptyValues,
};
